import React, { useState } from 'react';

export default function UserInput({ onSubmit, onEnd, isLoading }) {
    const [dialogue, setDialogue] = useState('');
    const [action, setAction] = useState('');

    const getAdditions = () => {
        const additions = [];
        if (action.trim()) {
            additions.push({ actor: 'user', type: 'action', content: action.trim() });
        }
        if (dialogue.trim()) {
            additions.push({ actor: 'user', type: 'dialogue', content: dialogue.trim() });
        }
        return additions;
    };

    const handleSubmit = () => {
        const additions = getAdditions();
        if (additions.length > 0) {
            onSubmit(additions);
            setDialogue('');
            setAction('');
        }
    };

    const handleEnd = () => {
        onEnd(getAdditions());
        setDialogue('');
        setAction('');
    };

    return (
        <div className="mt-4 card">
            <div className="card-body">
                <div className="form-group">
                    <label htmlFor="action-text"><strong>Action/Description:</strong></label>
                    <textarea
                        id="action-text"
                        value={action}
                        onChange={(e) => setAction(e.target.value)}
                        placeholder="e.g., He looks at the clock, nervously."
                        className="form-control"
                        rows="3"
                        disabled={isLoading}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="dialogue-text"><strong>Dialogue:</strong></label>
                    <textarea
                        id="dialogue-text"
                        value={dialogue}
                        onChange={(e) => setDialogue(e.target.value)}
                        placeholder={"e.g., CHARACTER NAME\nWe don't have much time."}
                        className="form-control"
                        rows="3"
                        disabled={isLoading}
                    />
                </div>
                <div className="d-flex justify-content-between">
                    <button onClick={handleSubmit} disabled={isLoading || (!dialogue.trim() && !action.trim())} className="btn btn-success">
                        {isLoading ? 'Submitting...' : 'Add to Scene'}
                    </button>
                    <button onClick={handleEnd} disabled={isLoading} className="btn btn-danger">
                        {isLoading ? 'Ending...' : 'End Scene'}
                    </button>
                </div>
            </div>
        </div>
    );
}

